import axios from 'axios'

const addPackage = async (cardId, formData) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_API_BASE_URL}systemUsers/addPackage/${cardId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        withCredentials: true,
      }
    )
    return response.data
  } catch (error) {
    throw error
  }
}

export default addPackage
